import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import user from './modules/user'
import getters from './getters'
import float from './modules/floatDialog'

Vue.use(Vuex)
const state = {
  loadding: false,
  loading2:false,
}
const store = new Vuex.Store({
  state,
  modules: {
    app,
    permission,
    tagsView,
    user,
    float
  },
  getters
})

export default store
